<!--
    Displays a Rich Text data item.
-->

<template>
    <div class="ql-viewer"
         :class="className"
         :style="style">
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="html" />
        <!-- eslint-enable -->
    </div>
</template>

<script setup>
    import { defineProps, computed, onMounted } from 'vue';
    import { convertToHtml } from '../js/RichTextUtilities.js';

    const props = defineProps({
        delta: {
            type: Object,
            default: null
        },
        className: {
            type: String,
            default: null
        },
        style: {
            type: String,
            default: null
        }
    });

    onMounted(() => {
    });

    const html = computed(() => convertToHtml(props.delta));

</script>

<style>
    .ql-editor h1,
    .ql-editor h2,
    .ql-editor h3,
    .ql-editor h4,
    .ql-editor h5,
    .ql-editor h6 {
        color: black;
        margin-top: 1em;
    }

    .ql-viewer {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
    }

    .ql-viewer > div {
        max-width: 100%;
    }

    .ql-viewer p,
    .ql-viewer h1,
    .ql-viewer h2,
    .ql-viewer h3,
    .ql-viewer h4,
    .ql-viewer h5,
    .ql-viewer h6,
    .ql-viewer span {
        word-wrap: break-word;
        overflow-wrap: break-word;
    }

    .ql-viewer img {
        max-width: 100%;
        height: auto;
        display: block;
    }

    .ql-viewer table {
        width: 100%;
        max-width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
    }

    .ql-viewer td,
    .ql-viewer th {
        word-wrap: break-word;
        overflow-wrap: break-word;
        border: 1px solid #000;
        padding: 4px 8px;
        width: auto;
    }
</style>
